import { h } from 'vue'
import { Modal } from 'ant-design-vue'

export function previewImage(url) {
  Modal.info({
    icon: null,
    title: null,
    width: '80%',
    maskClosable: true,
    closable: true,
    okButtonProps: { style: { display: 'none' } },
    content: h('div', {}, [
      h('img', {
        src: url,
        style: { width: '100%' }
      })
    ])
  })
}
